export default __webpack_public_path__ + "static/app-blue-bg-2b3f8dc954c2510806e6d01de149d53b.png";